import React from 'react'
import cn from 'classnames'

import './index.scss'
import svgIcons from './svgIcons'

interface IconProps {
    name: string,
    className?: string,
    width?: number,
    height?: number,
    canvasWidth?: number,
    canvasHeight?: number,
    onClick?: Function | any,
    loading?: boolean,
    rounded?: boolean,
    center?: boolean,
    disabled?: boolean,
}

export const Icon = ({
    name,
    className,
    width = 16,
    height,
    canvasWidth,
    canvasHeight,
    onClick,
    loading,
    rounded,
    center,
    disabled,
    ...rest
}: IconProps) => {

    const SvgIcon = svgIcons[name];

    const classes = cn('cb-icon', `cb-icon-${name.toLowerCase()}`, className, {
        'cursor-pointer': onClick,
        'flex justify-center items-center': center,
        'bg-blue': name === 'Operator',
        disabled,
        rounded,
        loading
    });
    return (
        <div
            style={{ width: canvasWidth, height: canvasHeight }}
            className={classes}
            onClick={onClick}
        >
            <SvgIcon
                width={width}
                height={height}
                aria-hidden="true"
                role="img"
                focusable={false}
                {...rest}
            />

        </div>
    );
};